<template>
  <b-button
    class="app-button"
    :class="{ 'app-button--icon-only': iconOnly }"
    :variant="variant"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </b-button>
</template>

<script>
  export default {
    inheritAttrs: false,
    props: {
      variant: {
        type: String,
        validator: value =>
          ['primary', 'secondary', 'tertiary'].indexOf(value) !== -1,
        default: 'primary',
      },
      iconOnly: Boolean,
    },
  }
</script>

<style lang="scss" src="./AppButton.scss"></style>
